import Pizza from './pizza.svg'
import Ramen from './ramen.svg'
import Coffee from './coffee.svg'
import Beer from './beer.svg'
import Shawarma from './shawarma.svg'
import Chicken from './chicken.svg'
import All from './all.svg'
import Shrimp from './shrimp.svg'
import Crab from './crab.svg'
import Beef from './beef.svg'
const obj = {
  pizza: Pizza,
  ramen: Ramen,
  coffee: Coffee,
  beer: Beer,
  shawarma: Shawarma,
  chicken: Chicken,
  all: All,
  shrimp: Shrimp,
  crab: Crab,
  beef: Beef
}

export default obj